import { render } from "./MyReviewForm.vue?vue&type=template&id=161aed67"
import script from "./MyReviewForm.vue?vue&type=script&lang=js"
export * from "./MyReviewForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__